import { render, staticRenderFns } from "./_SearchBlock.vue?vue&type=template&id=06ac24a6&"
import script from "./_SearchBlock.vue?vue&type=script&lang=js&"
export * from "./_SearchBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports